import { render, staticRenderFns } from "./Assesment.vue?vue&type=template&id=2bacec05&scoped=true&"
import script from "./Assesment.vue?vue&type=script&lang=js&"
export * from "./Assesment.vue?vue&type=script&lang=js&"
import style0 from "./Assesment.vue?vue&type=style&index=0&id=2bacec05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bacec05",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
